<template>
    <div class="guild-line-view">
        <span>To Be Developed</span>
    </div>
</template>

<script>
export default {
    name: 'GuildLineView'
}
</script>

<style scoped>
.guild-line-view {
    width: 100%;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>    